/**
 * @generated SignedSource<<4653926638fbdd2add09b9d89d412ba2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_ListView_groupResults$data = {
  readonly firstGroup?: {
    readonly issues: {
      readonly " $fragmentSpreads": FragmentRefs<"ui_issueNavigatorBulkOperationsConnectionsSubscriber_BulkOpsConnectionsSubscriber">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"NativeIssueTableWithSelectedIssuesProvider_group">;
  readonly " $fragmentType": "main_issueNavigator_ListView_groupResults";
};
export type main_issueNavigator_ListView_groupResults$key = {
  readonly " $data"?: main_issueNavigator_ListView_groupResults$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_ListView_groupResults">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "viewConfigInput",
  "variableName": "viewConfigInput"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fieldSetsInput"
    },
    {
      "kind": "RootArgument",
      "name": "fieldSetsScope"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isPaginating"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectKeys"
    },
    {
      "kind": "RootArgument",
      "name": "settings"
    },
    {
      "kind": "RootArgument",
      "name": "viewConfigInput"
    }
  ],
  "kind": "Fragment",
  "name": "main_issueNavigator_ListView_groupResults",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isPaginating",
          "variableName": "isPaginating"
        },
        {
          "kind": "Variable",
          "name": "projectKey",
          "variableName": "projectKey"
        },
        {
          "kind": "Variable",
          "name": "projectKeys",
          "variableName": "projectKeys"
        },
        (v0/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "NativeIssueTableWithSelectedIssuesProvider_group"
    },
    {
      "condition": "isPaginating",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "JiraSpreadsheetGroup",
          "kind": "LinkedField",
          "name": "firstGroup",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "fieldSetsInput",
                  "variableName": "fieldSetsInput"
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 50
                },
                {
                  "kind": "Variable",
                  "name": "scope",
                  "variableName": "fieldSetsScope"
                },
                {
                  "kind": "Variable",
                  "name": "settings",
                  "variableName": "settings"
                },
                (v0/*: any*/)
              ],
              "concreteType": "JiraIssueConnection",
              "kind": "LinkedField",
              "name": "issues",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ui_issueNavigatorBulkOperationsConnectionsSubscriber_BulkOpsConnectionsSubscriber"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraSpreadsheetGroupConnection"
};
})();

(node as any).hash = "e6b6bb177338755314ae9f53f351e67f";

export default node;
